export const MAX_DATASET_MESSAGES = 100;
export const MAX_DATASETS = 100;
export const MAX_USER_MESSAGE_CHARS = 5000;

const MESSAGE_SEPARATOR_REGEX = /^\s*-{3,}\s*$/m;

export const parsePastedMessages = (raw: string): string[] =>
  raw
    .split(MESSAGE_SEPARATOR_REGEX)
    .map((m) => m.trim())
    .filter(Boolean);

export const getScoreColor = (score: number): string => {
  if (score >= 4) return 'text-success';
  if (score >= 3) return 'text-warning';
  return 'text-destructive';
};
